import { Companion_instance1k9k9e3ajjzyi as Companion_instance } from './ActionPipe.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherPipeCannonClass;
function DispatcherPipeCannon() {
  if (DispatcherPipeCannonClass === VOID) {
    class $ {
      constructor(dispatcher, pipe) {
        pipe = pipe === VOID ? Companion_instance : pipe;
        this.dispatcher_1 = dispatcher;
        this.pipe_1 = pipe;
      }
      *fire_dhif5v_k$(action, $completion) {
        return yield* this.pipe_1.execute_h9qqcg_k$(this.dispatcher_1, action, $completion);
      }
      toString() {
        return 'DispatcherPipeCannon(dispatcher=' + toString(this.dispatcher_1) + ', pipe=' + toString_0(this.pipe_1) + ')';
      }
      hashCode() {
        var result = this.dispatcher_1 == null ? 0 : hashCode(this.dispatcher_1);
        result = imul(result, 31) + hashCode(this.pipe_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DispatcherPipeCannon()))
          return false;
        if (!equals(this.dispatcher_1, other.dispatcher_1))
          return false;
        if (!equals(this.pipe_1, other.pipe_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DispatcherPipeCannon', VOID, VOID, VOID, [1]);
    DispatcherPipeCannonClass = $;
  }
  return DispatcherPipeCannonClass;
}
//region block: exports
export {
  DispatcherPipeCannon as DispatcherPipeCannon3aitdk4bdtfxf,
};
//endregion

//# sourceMappingURL=ActionCannon.mjs.map
